import { render, staticRenderFns } from "./CompleteOrderResumeFloat.vue?vue&type=template&id=27312f1c&scoped=true&"
import script from "./CompleteOrderResumeFloat.vue?vue&type=script&lang=js&"
export * from "./CompleteOrderResumeFloat.vue?vue&type=script&lang=js&"
import style0 from "./CompleteOrderResumeFloat.vue?vue&type=style&index=0&id=27312f1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27312f1c",
  null
  
)

export default component.exports